import React, {
  createContext,
  useContext,
  useMemo,
  useState
} from 'react';

import { Context } from './types';

import {
  ROUTE_STATION_SERVICES_FILTERS,
  STATION_SERVICE_PRICE_TYPES,
  STATION_SERVICES_SORTING
} from '../../constants';

import {
  checkIsAllActiveFilter,
  checkIsTop5ByCountryActiveFilter,
  checkIsTopPriceEvery100kmActiveFilter,
  checkIsRouteStationServicesPricesInCountry,
  checkIsRouteStationServicesPricesInEUR,
  checkIsActiveStationsServicesDefaultSorting,
  checkIsActiveStationsServicesHightSorting,
  checkIsActiveStationsServicesLowSorting
} from '../../utils';

export const RouteStationServicesFilterContext = createContext({} as Context);
export const useRouteStationServicesFilterContext = () => useContext(RouteStationServicesFilterContext);

export const RouteStationServicesFilterProvider = ({ children }: { children: React.ReactNode }) => {
  const [ activeFilter, setActiveFilter ] = useState<Context['activeFilter']>(ROUTE_STATION_SERVICES_FILTERS.all);
  const [
    activeStationsServicesPrice,
    setActiveStationsServicesPrice
  ] = useState<Context['activeStationsServicesPrice']>(STATION_SERVICE_PRICE_TYPES.inEUR);

  const [
    activeStationsServicesSorting,
    setActiveStationsServicesSorting
  ] = useState<Context['activeStationsServicesSorting']>(STATION_SERVICES_SORTING.hight);

  const value = useMemo(() => ({
    activeFilter,
    isActiveAllFilter: checkIsAllActiveFilter(activeFilter),
    isActiveTop5Filter: checkIsTop5ByCountryActiveFilter(activeFilter),
    isActiveEvery100kmFilter: checkIsTopPriceEvery100kmActiveFilter(activeFilter),
    setActiveFilter,

    activeStationsServicesPrice,
    setActiveStationsServicesPrice,
    isActiveRouteStationsServicesPriceInEUR: checkIsRouteStationServicesPricesInEUR(activeStationsServicesPrice),
    isActiveRouteStationsServicesPriceInCountry: checkIsRouteStationServicesPricesInCountry(activeStationsServicesPrice),

    activeStationsServicesSorting,
    isActiveStationsServicesDefaultSorting: checkIsActiveStationsServicesDefaultSorting(activeStationsServicesSorting),
    isActiveStationsServicesHightSorting: checkIsActiveStationsServicesHightSorting(activeStationsServicesSorting),
    isActiveStationsServicesLowSorting: checkIsActiveStationsServicesLowSorting(activeStationsServicesSorting),
    setActiveStationsServicesSorting
  }), [
    activeFilter,
    setActiveFilter,

    activeStationsServicesPrice,
    setActiveStationsServicesPrice,

    activeStationsServicesSorting,
    setActiveStationsServicesSorting
  ]);

  return (
    <RouteStationServicesFilterContext.Provider value={value}>{children}</RouteStationServicesFilterContext.Provider>
  );
};
